import { render } from "./fileUploadBox.vue?vue&type=template&id=2b55e8cc"
import script from "./fileUploadBox.vue?vue&type=script&lang=js"
export * from "./fileUploadBox.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\EZZKAH\\IdeaProjects\\datapark\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__